import { FloorCompressed, FloorExceptionalClosingHoursResponse, LocationCompressed } from '@jooxter/api';
import { ExceptionalOpeningHoursTypeEnum, getIDateTimeFromDateTime, getIDateTimeFromISO } from '@jooxter/utils';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchUser } from '../../../queries';
import {
  IFloorExceptionalClosingHoursFormDefaultValues,
  IFloorExceptionalClosingHoursFormPreset,
} from '../types/floor-exceptional-closing-hours-form.types';

export const useFloorExceptionalClosingHoursFormDefaultValues = (
  preset?: IFloorExceptionalClosingHoursFormPreset,
  floorExceptionalClosingHoursToEdit?: FloorExceptionalClosingHoursResponse | null,
  floor?: FloorCompressed | null,
  selectedBuilding?: LocationCompressed
) => {
  const { t } = useTranslation();
  const { user } = useFetchUser();

  const defaultValues: IFloorExceptionalClosingHoursFormDefaultValues | undefined = useMemo(() => {
    if (!user?.id) {
      return;
    }

    if (floorExceptionalClosingHoursToEdit) {
      return {
        title:
          floorExceptionalClosingHoursToEdit.title ??
          t('manage-space-form.default-title-for-slot', {
            creatorFirstName: user.firstname,
            creatorLastName: user.lastname,
          }),
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        start: getIDateTimeFromISO(floorExceptionalClosingHoursToEdit.timestampFrom!, selectedBuilding?.timezone),
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        end: getIDateTimeFromISO(floorExceptionalClosingHoursToEdit.timestampTo!, selectedBuilding?.timezone),
      };
    }

    return {
      title: t('manage-space-form.default-title-for-slot', {
        creatorFirstName: user.firstname,
        creatorLastName: user.lastname,
      }),
      start: getIDateTimeFromDateTime(preset?.from, selectedBuilding?.timezone),
      end: getIDateTimeFromDateTime(preset?.to, selectedBuilding?.timezone),
      type: ExceptionalOpeningHoursTypeEnum.Closing,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, selectedBuilding?.timezone, preset, floorExceptionalClosingHoursToEdit, floor]);

  return defaultValues;
};
